import { render, staticRenderFns } from "./LpuCard.vue?vue&type=template&id=10b46c77&scoped=true&"
import script from "./LpuCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LpuCard.vue?vue&type=style&index=0&id=10b46c77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b46c77",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b46c77')) {
      api.createRecord('10b46c77', component.options)
    } else {
      api.reload('10b46c77', component.options)
    }
    module.hot.accept("./LpuCard.vue?vue&type=template&id=10b46c77&scoped=true&", function () {
      api.rerender('10b46c77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/LpuCard.vue"
export default component.exports